import * as angular from "angular";
import * as _ from "lodash";
import {BringozUnitConversionService} from "../services/bringoz-unit-conversion.service";


angular
  .module('bringoz.admin.commons')
  .filter('bringozPriceByLargeDistanceUnit', bringozPriceByLargeDistanceUnit);

function bringozPriceByLargeDistanceUnit(splitService, $filter, bringozUnitConversionService: BringozUnitConversionService) {
  const currency = splitService.getCurrencyCode();

  return function bringozPriceByLongDistanceFilter(price, defaultValue) {
    if (_.isUndefined(price)) {
      return defaultValue || '--';
    }
    return $filter('isoCurrency')((bringozUnitConversionService.pricePerMeterToLargeUnit(price)).toFixed(2), currency);
  }
}
